/**
 * Get pointer event
 * @param {String} type trigger type
 * @returns {EventArrayProps}
 */
const getTriggerEvents = (type) => {
  switch (true) {
    case type === "hover":
      return ["pointerenter", "pointerleave", "touchstart"];

    case type === "over":
      return ["pointerover"];

    case type === "animate":
      return ["animateenter", "animateleave"];

    case type === "click":
      return ["click"];

    case type === "active":
      return ["pointerdown"];

    case type === "focus":
      return ["focus", "blur"];

    case type === "focus-within":
      return ["focusin", "focusout"];

    case type === "select":
      return ["change"];

    case type === "change":
      return ["change"];

    case type === "check":
      return ["check", "uncheck", "change"];

    case type === "active":
      return ["pointerdown", "pointerup"];

    case type === "scroll":
      return ["scroll"];

    case type === "mouse" || type === "pointer":
      return ["pointermove", "touchmove"];

    case type === "viewport":
      return ["viewportenter", "viewportleave", "scroll"];

    case type === "timeout":
      return ["timeoutenter", "timeoutleave"];

    case type === "class":
      return ["classadded", "classremoved"];

    case type === "reference":
      return ["referenceenter", "referenceleave"];

    default:
      return [];
  }
};

export default getTriggerEvents;
